/*
  Metric names, formulas and the time zone of "today". Merged FIRST into
  TRANSLATION_MAPS in ./index.js, so existing translations of common words
  (Conversions, Unique…) still win. Keys are the English source.
*/

const ru = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Правила считают дни по UTC: «сегодня» начинается в 00:00 UTC и может не совпадать с отчётами.",
  "Days are counted in the time zone set in Settings.": "Дни считаются по часовому поясу из настроек.",
  "CR % = conversions ÷ clicks × 100": "CR % = конверсии ÷ клики × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Уникальные клики: посетитель считается один раз в пределах окна уникальности кампании.",
  "Conversions": "Конверсии",
  "CR %": "CR %",
  "Unique": "Уникальные",
};

const es = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Las reglas cuentan los días en UTC: «hoy» empieza a las 00:00 UTC y puede no coincidir con los informes.",
  "Days are counted in the time zone set in Settings.": "Los días se cuentan en la zona horaria de Ajustes.",
  "CR % = conversions ÷ clicks × 100": "CR % = conversiones ÷ clics × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Clics únicos: un visitante cuenta una vez dentro de la ventana de unicidad de la campaña.",
  "Conversions": "Conversiones",
  "CR %": "CR %",
  "Unique": "Únicos",
};

const pt = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "As regras contam os dias em UTC: \"hoje\" começa às 00:00 UTC e pode não coincidir com os relatórios.",
  "Days are counted in the time zone set in Settings.": "Os dias são contados no fuso horário das Configurações.",
  "CR % = conversions ÷ clicks × 100": "CR % = conversões ÷ cliques × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Cliques únicos: um visitante conta uma vez dentro da janela de unicidade da campanha.",
  "Conversions": "Conversões",
  "CR %": "CR %",
  "Unique": "Únicos",
};

const de = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Regeln zählen Tage in UTC: „heute\" beginnt um 00:00 UTC und kann von den Berichten abweichen.",
  "Days are counted in the time zone set in Settings.": "Tage werden in der Zeitzone aus den Einstellungen gezählt.",
  "CR % = conversions ÷ clicks × 100": "CR % = Conversions ÷ Klicks × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Eindeutige Klicks: Ein Besucher zählt innerhalb des Eindeutigkeitsfensters der Kampagne einmal.",
  "Conversions": "Conversions",
  "CR %": "CR %",
  "Unique": "Eindeutig",
};

const fr = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Les règles comptent les jours en UTC : « aujourd’hui » commence à 00:00 UTC et peut différer des rapports.",
  "Days are counted in the time zone set in Settings.": "Les jours sont comptés dans le fuseau horaire des Paramètres.",
  "CR % = conversions ÷ clicks × 100": "CR % = conversions ÷ clics × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Clics uniques : un visiteur compte une fois dans la fenêtre d’unicité de la campagne.",
  "Conversions": "Conversions",
  "CR %": "CR %",
  "Unique": "Uniques",
};

const it = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Le regole contano i giorni in UTC: \"oggi\" inizia alle 00:00 UTC e può non coincidere con i report.",
  "Days are counted in the time zone set in Settings.": "I giorni sono contati nel fuso orario delle Impostazioni.",
  "CR % = conversions ÷ clicks × 100": "CR % = conversioni ÷ clic × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Clic unici: un visitatore conta una volta nella finestra di unicità della campagna.",
  "Conversions": "Conversioni",
  "CR %": "CR %",
  "Unique": "Unici",
};

const pl = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Reguły liczą dni w UTC: „dziś\" zaczyna się o 00:00 UTC i może się różnić od raportów.",
  "Days are counted in the time zone set in Settings.": "Dni są liczone w strefie czasowej z Ustawień.",
  "CR % = conversions ÷ clicks × 100": "CR % = konwersje ÷ kliknięcia × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Unikalne kliknięcia: odwiedzający liczy się raz w oknie unikalności kampanii.",
  "Conversions": "Konwersje",
  "CR %": "CR %",
  "Unique": "Unikalne",
};

const tr = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Kurallar günleri UTC’ye göre sayar: \"bugün\" 00:00 UTC’de başlar ve raporlardan farklı olabilir.",
  "Days are counted in the time zone set in Settings.": "Günler Ayarlar’daki saat dilimine göre sayılır.",
  "CR % = conversions ÷ clicks × 100": "CR % = dönüşümler ÷ tıklamalar × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Benzersiz tıklamalar: bir ziyaretçi, kampanyanın benzersizlik aralığında bir kez sayılır.",
  "Conversions": "Dönüşümler",
  "CR %": "CR %",
  "Unique": "Benzersiz",
};

const uk = {
  "Rules count days in UTC: \"today\" starts at 00:00 UTC and may differ from the reports.": "Правила рахують дні за UTC: «сьогодні» починається о 00:00 UTC і може не збігатися зі звітами.",
  "Days are counted in the time zone set in Settings.": "Дні рахуються за часовим поясом із налаштувань.",
  "CR % = conversions ÷ clicks × 100": "CR % = конверсії ÷ кліки × 100",
  "Unique clicks: a visitor counts once within the uniqueness window of the campaign.": "Унікальні кліки: відвідувач рахується один раз у межах вікна унікальності кампанії.",
  "Conversions": "Конверсії",
  "CR %": "CR %",
  "Unique": "Унікальні",
};

const METRIC_NAMES = { ru, es, pt, de, fr, it, pl, tr, uk };
export default METRIC_NAMES;
